import { Availability } from "@/types";
import { atom } from "jotai";

const availabilitiesAtom = atom<Availability[]>([])

export default availabilitiesAtom
